<template>
  <div class="track-and-trace-editor d-flex flex-column">
    <div class="cms-editor-ctn mt-2 pa-3 pl-0 d-flex flex-row flex-grow-1">
      <div class="toolbox-ctn px-3 font-weight-light flex-shrink-0">
        <span class="font-weight-light">
        {{$t('trackandtrace_think_about_steps')}}<br><br>
        {{$t('trackandtrace_each_step_location_pin')}}<br><br>
        {{$t('trackandtrace_click_icon_to_configure_pre')}}
        <v-icon color="accent">mdi-cog-outline</v-icon>
        {{$t('trackandtrace_click_icon_to_configure_post')}}
        </span>
        <v-btn @click="createStep" text block class="mt-4" color="primary">
          <v-icon>mdi-plus</v-icon>
          {{$t('trackandtrace_add_new_step')}}
        </v-btn>
      </div>
      <div class="drop-area-ctn flex-grow-1 flex-shrink-1 pa-2">
        <div class="drop-area-header  font-weight-bold">{{$t('trackandtrace_working_area')}}</div>
        <draggable class="drop-area flex-shrink-1" v-model="journey" group="a">
          <div class="journey-step my-2" v-for="(step, index) in journey" :key="`journey-step-${tabId}-${step.key}`">
            <journey-step :step-index="index" :step="step" :ref="`step-${index}`"></journey-step>
          </div>
        </draggable>
      </div>
    </div>
  </div>

</template>

<script>

import draggable from 'vuedraggable'
import { mapGetters, mapMutations } from 'vuex'
import JourneyStep from '@/components/editor/JourneyStep'
import utils from '@/utils/generateRandomKey'

export default {
  name: 'TrackAndTrace',
  props: ['tabId'],
  components: {
    draggable,
    'journey-step': JourneyStep
  },
  computed: {
    ...mapGetters(['stcTabs', 'getTabVisibility', 'defaultLanguage']),
    journey: {
      get () {
        const journey = this.$store.getters.getJourney

        // Update legacy T&T to include a key
        journey.forEach((step) => {
          if (!step.key) {
            step.key = utils.generateRandomKey()
          }
        })
        // --------

        return journey
      },
      set (journey) {
        this.updateJourney(journey)
      }
    },
    tabName: {
      get () {
        return this.$store.getters.getTabName(this.tabId)
      },
      set (name) {
        this.$store.dispatch('updateTabName', { tabId: this.tabId, name })
      }
    }
  },
  watch: {
    stcTabs: {
      deep: true,
      handler (tabs) {
        this.tabVisibility = this.getTabVisibility(this.tabId)
      }
    },
    tabVisibility: {
      deep: true,
      handler (visibility) {
        this.$store.dispatch('updateTabVisibility', { tabId: this.tabId, visibility })
      }
    }
  },
  mounted () {
    this.tabVisibility = this.getTabVisibility(this.tabId)
  },
  data () {
    return {
      tabVisibility: {},
      enabled: true
    }
  },
  methods: {
    ...mapMutations({
      updateJourney: 'SET_TRACK_AND_TRACE_JOURNEY'
    }),

    deleteTab () {
      this.$emit('delete-tab', this.tabId)
    },

    createStep () {
      const step = {
        name: {},
        location: {},
        date: '',
        lat: '',
        lng: '',
        key: utils.generateRandomKey()
      }

      step.name[this.defaultLanguage] = ''
      step.location[this.defaultLanguage] = ''

      this.$store.dispatch('addJourneyStep', { stepData: step })
      this.$nextTick(() => {
        this.$refs[`step-${this.journey.length - 1}`][0].openStepEdit()
      })
    }
  }
}

</script>

<style lang="sass">

@import "@/variables.sass"

.track-and-trace-editor
  height: 100%
  padding: 10px
  background: $bg-grey

</style>
